import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
export var useShouldShowVerticalImages = function() {
    var categoryModel = useCurrentCategoryModel();
    var mostSpecificPathIdentifier = (categoryModel !== null && categoryModel !== void 0 ? categoryModel : {}).mostSpecificPathIdentifier;
    var shouldShowVerticalTile = useCategoryStore().shouldShowVerticalTile;
    return shouldShowVerticalTile(mostSpecificPathIdentifier);
};
